<template>
  <div>
    <div class="header">
      <h1 class="page-title">用户信息</h1>
    </div>
    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="clearfix">
        <div class="ren-new">
          <img src="../../../assets/user/seluser.png" />
          <span>个人信息</span>
        </div>
        <div class="ren-new rborder">
          <img src="../../../assets/user/user.png" />
          <span>企业信息</span>
        </div>
      </div>
      <div class="cont-box">
        <div class="cont-left">
          <div class="line"></div>
          <div class="f">
            <form name="theform">
              <input
                style="display:none"
                type="radio"
                name="myradio"
                checked="true"
                value="local_name"
              />
              <input style="display:none" type="radio" name="myradio" value="random_name" />
              <input style="display:none" type="text" id="dirname" :value="filePath" size="50" />
            </form>
            <div class="contaniner">
              <a href="javascript:void(0);" id="selectfiles">
                <img :src="avatar" />
              </a>
            </div>
            <div id="ossfile"></div>
          </div>

          <span>{{ruleForm.username}}</span>
          <span class="grade">普通VIP</span>
          <!-- <div class="userimg">
            <img src="../../../assets/user/shanchuan.png" class="shangpic" />
            <i>修改头像</i>
          </div>-->
        </div>
        <div class="cont-right clearfix">
          <div class="r-hea">
            <img src="../../../assets/user/qita.png" />
            <span>个人基本信息</span>
          </div>
          <el-form class="r-cont" ref="ruleForm" :model="ruleForm" :rules="rules">
            <div class="one">
              <span>我的简称</span>
              <el-input v-model="jname" :disabled="true"></el-input>
              <span class="one-r">真实姓名</span>
              <input type="text" placeholder="请输入您的真实姓名" v-model="ruleForm.nickname" />
            </div>
            <div class="one">
              <span>联系电话</span>
              <input type="text" placeholder="请输入您的联系电话" v-model="ruleForm.mobile" />
              <span class="one-r">用户性别</span>
              <div class="sex" v-if="ruleForm.gender==0">
                <input class="my2" type="radio" name="sex" @click="man" />
                <i>男</i>
                <input class="my3" type="radio" name="sex" @click="woman" />
                <i>女</i>
              </div>
              <div class="sex" v-else-if="ruleForm.gender==1">
                <input class="my2" type="radio" name="sex" checked @click="man" />
                <i>男</i>
                <input class="my3" type="radio" name="sex" @click="woman" />
                <i>女</i>
              </div>
              <div class="sex" v-else>
                <input class="my2" type="radio" name="sex" @click="man" />
                <i>男</i>
                <input class="my3" type="radio" name="sex" checked @click="woman" />
                <i>女</i>
              </div>
            </div>
            <div class="one">
              <span>选择地址</span>
              <v-distpicker
                @selected="onSelected"
                :province="adr.province"
                :city="adr.city"
                :area="adr.area"
              ></v-distpicker>
            </div>
            <div class="one">
              <span>详细地址</span>
              <input
                type="text"
                v-model="ruleForm.addressxq"
                placeholder="请输入您的详细地址"
                class="one-dizhi"
              />
            </div>
          </el-form>
          <el-button class="sy-sub" type="primary" @click="submitForm('ruleForm')">保存</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import VDistpicker from 'v-distpicker'

import '../../../../public/PLupload/lib/crypto1/crypto/crypto.js'
import '../../../../public/PLupload/lib/crypto1/hmac/hmac.js'
import '../../../../public/PLupload/lib/crypto1/sha1/sha1.js'
import '../../../../public/PLupload/lib/base64.js'
import plupload from 'plupload'

let accessid = 'LTAIKIMZYqT7o3sd'
let accesskey = 'bOqt3eOIbDRYkaDIgb84Q8dKyJF6fT'
let host = 'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com'

let g_dirname = ''
let g_object_name = ''
let g_object_name_type = ''
let timestamp
let now = (timestamp = Date.parse(new Date()) / 1000)
let pos = ''
let suffix = ''

const baseUlr = window.location.host
const url = !baseUlr.includes('192')
  ? 'https://' + baseUlr
  : 'https://www.yunshanyin.net'

var policyText = {
  expiration: '2030-05-01T12:00:00.000Z', // 设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
  conditions: [
    ['content-length-range', 0, 104857600000000] // 设置上传文件的大小限制
  ]
}
var policyBase64 = window.Base64.encode(JSON.stringify(policyText))
let message = policyBase64
var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, { asBytes: true })
var signature = Crypto.util.bytesToBase64(bytes)

function check_object_radio() {
  var tt = document.getElementsByName('myradio')
  for (var i = 0; i < tt.length; i++) {
    if (tt[i].checked) {
      g_object_name_type = tt[i].value
      break
    }
  }
}

function get_dirname() {
  let dir = document.getElementById('dirname').value
  if (dir != '' && dir.indexOf('/') != dir.length - 1) {
    dir = dir + '/'
  }
  g_dirname = dir
}

function random_string(len, filename) {
  let pwd = filename
  return pwd
}

function get_suffix(filename) {
  pos = filename.lastIndexOf('.')
  suffix = ''
  if (pos != -1) {
    suffix = filename.substring(pos)
  }

  return suffix
}

function calculate_object_name(filename) {
  if (g_object_name_type == 'local_name') {
    g_object_name += '${filename}'
  } else if (g_object_name_type == 'random_name') {
    suffix = get_suffix(filename)
    g_object_name = g_dirname + random_string(10, filename)
  }
  return ''
}

function get_uploaded_object_name(filename) {
  if (g_object_name_type == 'local_name') {
    let tmp_name = g_object_name
    tmp_name = tmp_name.replace('${filename}', filename)
    return tmp_name
  } else if (g_object_name_type == 'random_name') {
    return g_object_name
  }
}

function set_upload_param(up, filename, ret) {
  g_object_name = g_dirname
  if (filename != '') {
    suffix = get_suffix(filename)
    calculate_object_name(filename)
  }
  let new_multipart_params = {
    key: g_object_name,
    policy: policyBase64,
    OSSAccessKeyId: accessid,
    success_action_status: '200', //让服务端返回200,不然，默认会返回204
    signature: signature
  }

  up.setOption({
    url: host,
    multipart_params: new_multipart_params
  })

  up.start()
}

export default {
  components: { VDistpicker },
  data() {
    return {
      avatar: '',
      jname: '',
      ruleForm: {
        //省市区id
        address: [],
        // 详细地址信息
        addressxq: '',
        //名字
        nickname: '',
        // 用户名
        username: '',
        //性别
        gender: '',
        // 手机号码
        mobile: '',
        token: window.localStorage.getItem('token')
      },
      rules: {
        nickname: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { min: 11, max: 11, message: '请核对手机号码', trigger: 'blur' }
        ],
        addressxq: [
          { required: true, message: '请输入配送地址', trigger: 'blur' },
          {
            min: 5,
            max: 120,
            message: '详细地址长度需要在5-120个汉字或字符之间',
            trigger: 'blur'
          }
        ]
      },
      adr: {
        province: '',
        city: '',
        area: ''
      },
      loading: true,
      filePath: ''
    }
  },
  methods: {
    // 个人信息
    async getYue() {
      this.loading = true
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      if (res.data.avatar) {
        this.avatar = res.data.avatar
        let userobj = {
          id: res.data.id,
          username: res.data.username,
          mobile: res.data.mobile,
          avatar: res.data.avatar,
          nickname: res.data.nickname
        }
        window.localStorage.setItem('u', JSON.stringify(userobj))
      } else {
        let u = window.localStorage.getItem('u')
        this.avatar = JSON.parse(u).avatar
      }

      this.ruleForm.username = res.data.username
      this.ruleForm.nickname = res.data.nickname
      this.ruleForm.mobile = res.data.mobile

      this.ruleForm.gender = res.data.gender
      this.jname = res.data.jname
      this.ruleForm.addressxq = res.data.addressxq
      this.loading = false
      if (res.data.address) {
        let adr = res.data.address.split(',')
        this.adr.province = adr[0]
        this.adr.city = adr[1]
        this.adr.area = adr[2]
      }
    },
    //性别
    man() {
      this.ruleForm.gender = 1
    },
    woman() {
      this.ruleForm.gender = 2
    },
    // 验证填写是否完全
    submitForm(formName) {
      if (this.ruleForm.gender == 0) {
        this.$message('请选择性别', 'error')
        return
      }
      if (this.ruleForm.address.length < 3) {
        this.$message('请选择完整的省市区', 'error')
        return
      }
      for (let i = 0; i < this.ruleForm.address.length; i++) {
        if (!this.ruleForm.address[i]) {
          this.$message('请选择完整的省市区', 'error')
          return
        }
      }
	 
      this.$refs[formName].validate(async valid => {
        if (!valid) {
          return
        } else {
          if (!this.ruleForm.addressxq) {
            this.$message('请选择详细地区信息', '提示')
            return
          }
          if (typeof this.ruleForm.address == 'string') {
            this.ruleForm.address = this.ruleForm.address.split(',')
          }
          this.ruleForm.address = this.ruleForm.address.join(',')
          let param = new URLSearchParams()
          for (let key in this.ruleForm) {
            param.append(key, this.ruleForm[key])
          }
          param.append('avatar', this.avatar)
          const { data: res } = await this.$http({
            method: 'post',
            url: 'api/mine/editinfo',
            data: param
          })
          if (res.code == 1) {
            this.$confirm('修改资料成功！', '提示')
            this.getYue()
            // let userobj = {
            //   id: res.data.id,
            //   username: res.data.username,
            //   mobile: res.data.mobile,
            //   avatar: res.data.avatar,
            //   nickname: res.data.nickname
            // }

            // window.localStorage.setItem('u', JSON.stringify(userobj))
            // this.queryAddress()
          } else {
            this.$confirm('修改资料失败', '提示')
          }
        }
      })
    },
    //地址
    onSelected(data) {
      this.ruleForm.address = []
      for (let key in data) {
        this.ruleForm.address.push(data[key].value)
      }
    }
  },
  created() {
    if (!window.localStorage.getItem('token')) {
      this.$router.replace('/login')
      return
    }
    let u = JSON.parse(window.localStorage.getItem('u'))
    this.filePath =
      'uploads/' +
      u.mobile +
      '/' +
      new Date().toLocaleDateString().replace(/\//g, '-')
    this.getYue()
  },
  mounted() {
    const that = this
    var uploader = new plupload.Uploader({
      runtimes: 'html5,flash,silverlight,html4',
      browse_button: 'selectfiles',
      flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
      silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
      url: 'http://oss.aliyuncs.com',
      filters: {
        mime_types: [
          { title: 'Image files', extensions: 'jpg' },
          { title: 'Png files', extensions: 'png' },
          { title: 'Rar files', extensions: 'rar' },
          { title: 'Zip files', extensions: 'zip' },
          { title: 'Gif files', extensions: 'gif' }
        ]
      },
      init: {
        PostInit: function() {
          document.getElementById('ossfile').innerHTML = ''
        },
        FilesAdded: function(up, files) {
          set_upload_param(uploader, '', false)
          plupload.each(files, function(file) {
            document.getElementById('ossfile').innerHTML +=
              '<div style="display:none" id="' +
              file.id +
              '">' +
              file.name +
              ' (' +
              plupload.formatSize(file.size) +
              ')<b></b>' +
              '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>' +
              '</div>'
          })
        },

        BeforeUpload: function(up, file) {
          check_object_radio()
          get_dirname()
          set_upload_param(up, file.name, true)
        },
        // 上传进度显示
        UploadProgress: function(up, file) {
          var d = document.getElementById(file.id)
          d.getElementsByTagName('b')[0].innerHTML =
            '<span>' + file.percent + '%</span>'
          var prog = d.getElementsByTagName('div')[0]
          var progBar = prog.getElementsByTagName('div')[0]
          progBar.style.width = 3 * file.percent + 'px'
          progBar.setAttribute('aria-valuenow', file.percent)
        },
        // 上传完成后
        FileUploaded: function(up, file, info) {
          that.avatar =
            'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com/' +
            get_uploaded_object_name(file.name)
            $('.toux').attr('src',that.avatar)
          that.$confirm('更换头像成功，请点击下方保存', '提示')
        },

        Error: function(up, err) {
          document
            .getElementById('console')
            .appendChild(document.createTextNode('\nError xml:' + err.response))
        }
      }
    })

    uploader.init()
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.distpicker-address-wrapper {
  margin-left: 6px;
}
.el-input {
  width: 280px;
  margin-left: 6px;
}
.el-input__inner {
  height: 36px;
  line-height: 36px;
}
.box-card {
  .clearfix {
    .ren-new {
      width: 114px;
      height: 36px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 4px rgba(14, 175, 99, 0.2);
      opacity: 1;
      border-radius: 4px;
      font-size: 16px;
      margin-right: 20px;
      float: left;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-right: 4px;
      }
    }
    .rborder {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
    }
  }
  .cont-box {
    display: flex;

    .cont-left {
      position: relative;
      width: 161px;
      height: 675px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .line {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 92%;
        border-right: 2px solid #eee;
      }
      img {
        width: 80px;
        height: 80px;
        margin-top: 22px;
      }
      span {
        display: block;
        font-size: 16px;
        font-weight: 400;
        line-height: 27px;
        margin-top: 24px;
        color: rgba(89, 89, 89, 1);
        opacity: 1;
      }
      .grade {
        font-size: 12px;
        margin-top: 0px;
      }
      .userimg {
        display: flex;
        width: 161px;
        height: 30px;
        align-items: center;
        justify-content: center;
        color: rgba(24, 144, 255, 1);
        .shangpic {
          width: 21px;
          height: 14px;
          margin-top: 0;
          margin-right: 4px;
        }
      }
    }
    .cont-right {
      padding: 0 30px;
      box-sizing: border-box;
      .r-hea {
        width: 1352px;
        height: 34px;
        background: rgba(24, 144, 255, 0.05);
        opacity: 1;
        display: flex;
        align-items: center;
        padding-left: 10px;
        box-sizing: border-box;
        font-size: 14px;
        img {
          margin-right: 4px;
        }
      }
      .r-cont {
        .one {
          font-size: 14px;
          margin: 20px 0;
          margin-left: 30px;
          display: flex;
          .one-defa {
            background: #eee;
          }
          .one-r {
            margin-left: 50px;
          }
          .my2,
          .my3 {
            width: 15px;
            height: 15px;
          }
          .sex {
            width: 120px;
            height: 36px;
            display: flex;
            align-items: center;
            i {
              margin-right: 10px;
            }
          }
          .sele {
            width: 280px;
            height: 36px;
            margin-left: 6px;
          }
          .one-dizhi {
            border: 1px solid #eee;
            width: 711px;
          }
        }
        input {
          width: 280px;
          height: 36px;
          border: 1px solid #eee;
          margin-left: 6px;
          padding-left: 4px;
          box-sizing: border-box;
        }
        span {
          display: block;
          width: 70px;
          line-height: 35px;
          font-size: 14px;
          text-align: right;
        }
      }
    }
  }
}
.sy-sub {
  float: left;
  margin: 30px;
}
</style>